import React from 'react'
import Fotter from '../Home/Home_modules/Footerr/Footer_main';

function wallet_connect() {
    return (
        <div>


        
<Fotter/>  
        </div>
    )
}

export default wallet_connect
